'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { ProductHero, styles } from '../../product-landing/ProductLanding';
import McpPreview from '../components/McpPreview';

export default function HeroSection() {
  const { t } = useTranslation('start');
  return (
    <ProductHero
      eyebrow={t('mcp.hero.eyebrow')}
      title={t('mcp.hero.title')}
      intro={t('mcp.hero.subtitle')}
      preview={<McpPreview />}
    >
      {/* No utm_* on an internal link: GA4 reads it as a new campaign and
          restarts the session on our own page (A-2026-09-21-1). */}
      <Link href="/rejestracja" className={styles.primaryButton}>
        {t('mcp.hero.ctaPrimary')}
      </Link>
      <Link href="/blog/czy-ai-zna-polskie-prawo-benchmark-mcp" className={styles.secondaryButton}>
        {t('mcp.hero.ctaSecondary')}
      </Link>
    </ProductHero>
  );
}
